import React from "react";
import { INavConfig } from "./Constants";

interface IAnalyserWrapperProps {
    NavItems: INavConfig[];
    Session: string;
}

export const AnalyserWrapper: React.FC<IAnalyserWrapperProps> = props => {
    return (
        <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
            <div className="kt-subheader kt-grid__item" id="kt_subheader">
                <div className="kt-container  kt-container--fluid ">
                    <div className="kt-subheader__main">
                        <ul className="nav" role="tablist">
                            {props.NavItems.map((navItem, index) => (
                                <li className="nav-item" key={index}>
                                    <a className={`btn kt-subheader__btn-secondary${index === 0 ? " active" : ""}`} data-toggle="tab" href={`#${navItem.Href}`}>
                                        {navItem.Title}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="kt-subheader__toolbar">
                        <div className="kt-subheader__wrapper">
                            <a href={`/dpa/Sessione/${props.Session}`} className="btn btn-outline-success btn-pill btn-sm">
                                <i className="fa fa-arrow-left" />
                                Indietro
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="kt-portlet min-vh-100">
                <div className="kt-portlet__head header_dpa">
                    <div className="kt-portlet__head-label">
                        <span className="kt-portlet__head-icon ">
                            <i className="fa fa-users" />
                        </span>
                        <h3 className="kt-portlet__head-label">Digital Product Analyser</h3>
                    </div>
                </div>
                <form className="kt-form login-form login-form--fit kt-form login-form--label-align-right">
                    <div className="kt-portlet__body content_dpa">
                        <div className="tab-content">{props.children}</div>
                    </div>
                </form>
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/DigitalProductAnalyser/AnalyserWrapper.tsx